import React from "react";
import * as Mui from "@mui/material";
import { Integration } from "model/integration";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

interface Props {
	open: boolean;
	onClose: () => void;
	integration: Integration;
}

export function WixModal({ open, onClose, integration }: Props) {
	const dashboard = `https://manage.wix.com/dashboard/${integration.data.wixSiteId}/home`;
	const editor = `https://manage.wix.com/editor/${integration.data.wixSiteId}/`;

	return (
		<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
			<Mui.Box display="flex" flexDirection="column" style={{ gap: 16 }}>
				<Mui.Typography variant="body2" color="textSecondary">
					Your Wix site is connected. Use the links below to manage your site.
				</Mui.Typography>
				<Mui.Box display="flex" style={{ gap: 12 }}>
					<Mui.Button
						variant="outlined"
						size="small"
						href={dashboard}
						target="_blank"
						rel="noopener noreferrer"
					>
						View Dashboard
					</Mui.Button>
					<Mui.Button
						variant="outlined"
						size="small"
						href={editor}
						target="_blank"
						rel="noopener noreferrer"
					>
						View Editor
					</Mui.Button>
				</Mui.Box>
			</Mui.Box>
		</SimpleIntegrationModal>
	);
}
